"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentLoginBg = _interopRequireDefault(require("../assets/student-login-bg.png"));
require("./styles.scss");
var _CleverLogin = _interopRequireDefault(require("./CleverLogin"));
var _LastUsedClass = _interopRequireDefault(require("./LastUsedClass"));
var _interfacesAndConstants = require("./interfacesAndConstants");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _SuiTurnstile = require("schoolUiComponents/SuiTurnstile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var getCookie = function getCookie(name) {
  var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
var StudentLogin = exports.StudentLogin = function StudentLogin(_ref) {
  var _rememberMeKlassDetai3;
  var _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton;
  var rememberMeKlassDetails = null;
  try {
    rememberMeKlassDetails = getCookie("logged_in_klasses_info_remember_me_details") && JSON.parse(getCookie("logged_in_klasses_info_remember_me_details"));
    rememberMeKlassDetails.sort(function (a, b) {
      return new Date(b.last_login).valueOf() - new Date(a.last_login).valueOf();
    });
  } catch (e) {}
  (0, _react.useEffect)(function () {
    var _rememberMeKlassDetai;
    // useeffect get triggered on loading of class code, qr code and student username screen
    if (window.location.hash === '#/student') {
      trackEventsForGuests("Viewed Login Method Selection Screen", {
        "mp_login_user_type": "student"
      }, {
        send_mixpanel: true
      });
    }
    if (((_rememberMeKlassDetai = rememberMeKlassDetails) === null || _rememberMeKlassDetai === void 0 ? void 0 : _rememberMeKlassDetai.length) > 0) {
      var _rememberMeKlassDetai2;
      (0, _pushEventToGTM.pushEventToGTM)('viewed_saved_class_student_login_screen', {
        'Intent for': 'login',
        'Screen type': 'page',
        'From Page': 'signin',
        'Available classes': (_rememberMeKlassDetai2 = rememberMeKlassDetails) === null || _rememberMeKlassDetai2 === void 0 ? void 0 : _rememberMeKlassDetai2.length
      });
    } else {
      (0, _pushEventToGTM.pushEventToGTM)('viewed_student_login_screen', {
        'Intent for': 'login',
        'Screen type': 'page',
        'From Page': 'signin'
      });
    }
  }, []);
  var sendInteractedEvent = function sendInteractedEvent(label) {
    trackEventsForGuests("Interacted Login Method Selection Screen", {
      "mp_login_user_type": "student",
      "Clicked on": label
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login",
    "data-sentry-component": "StudentLogin",
    "data-sentry-source-file": "index.tsx"
  }, showBackButton && /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back",
    onClick: function onClick() {
      sendInteractedEvent("Back Button");
      window.location.hash = "";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-bg"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _studentLoginBg["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-body select-login"
  }, ((_rememberMeKlassDetai3 = rememberMeKlassDetails) === null || _rememberMeKlassDetai3 === void 0 ? void 0 : _rememberMeKlassDetai3.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_SuiTurnstile.SuiTurnstileProvider, {
    action: "KLASS_CODE_LOGIN",
    userType: "student",
    featureName: _SuiTurnstile.TurnstileEnabledFeature.klass_code_login
  }, /*#__PURE__*/_react["default"].createElement(_LastUsedClass["default"], {
    rememberMeKlassDetails: rememberMeKlassDetails,
    sendInteractedEvent: sendInteractedEvent
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, "Choose your login method"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-types"
  }, _interfacesAndConstants.LOGIN_TYPE === null || _interfacesAndConstants.LOGIN_TYPE === void 0 ? void 0 : _interfacesAndConstants.LOGIN_TYPE.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      "data-test-id": type.label === "Class code" ? 'class-code-login' : 'qr-code-login',
      href: type.path,
      className: "login-type",
      onClick: function onClick() {
        return sendInteractedEvent(type.label);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: type.icon,
      alt: type.label
    }), /*#__PURE__*/_react["default"].createElement("label", null, type.label));
  })), /*#__PURE__*/_react["default"].createElement(_CleverLogin["default"], null))));
};